import React from "react";
import { domainData } from "./Data";
import { Row, Col } from "react-bootstrap";
import "./DomainResults.css";

function CreateDomainCard(props) {
  return (
    <Col md={6} lg={4}>
      <div className="sss-domain-card">
        <div className="domain-img">
          <img src={props.src} alt="" />
        </div>
        <div
          className="domain-name"
          style={{ borderBottom: "5px solid " + props.color }}
        >
          {props.domainName}
        </div>
        <div className="domain-desc">{props.desc}</div>
        <div className="domain-result">
          <p>
            Your scores suggest <strong>{props.result}</strong> {props.text1}
          </p>
          <p>{props.text2}</p>
        </div>
      </div>
    </Col>
  );
}

function DomainResults() {
  return (
    <div>
      <Row>{domainData.map(CreateDomainCard)}</Row>
    </div>
  );
}

export default DomainResults;
